import React, { useState } from "react";
import { useTheme } from "./ThemeContext";
import { useAuth } from "./AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import "./Header.css";

function Header() {
  const { theme, toggleTheme, isDark } = useTheme();
  const { showAuthModal, user, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // detect if on /qrgenerate page
  const isQRPage = location.pathname === "/qrgenerate";

  const getUserInitials = (email) => {
    if (!email) return "U";
    const name = email.split("@")[0];
    return name.charAt(0).toUpperCase();
  };

  const handleSignOut = () => {
    logout();
    setShowDropdown(false);
  };

  return (
    <header className={`header ${isQRPage ? "dark-header" : ""}`}>
      <div className="header-left">
        <img src="/headerlogo.png" alt="Queret.ai Logo" className="logo-image" />
        <h1 className="logo">Queret.ai</h1>
      </div>

      <div className="header-right">
        {user ? (
          <div className="user-menu">
            <div
              className="user-avatar"
              onClick={() => setShowDropdown(!showDropdown)}
              aria-label="User menu"
            >
              <span className="user-initials">{getUserInitials(user.email)}</span>
            </div>

            {showDropdown && (
              <div className="dropdown-menu">
                <div className="dropdown-item user-info">
                  <span className="user-email">{user.email}</span>
                </div>
                <div className="dropdown-divider"></div>
                <button
                  className="dropdown-item sign-out-btn"
                  onClick={handleSignOut}
                >
                  Sign Out
                </button>
              </div>
            )}
          </div>
        ) : (
          <>
            <button className="login-btn" onClick={() => navigate("/pricing-plans")}>
              Pricing
            </button>
            <button className="login-btn" onClick={() => showAuthModal("login")}>
              Log In
            </button>
            <button className="signup-btn" onClick={() => showAuthModal("signup")}>
              Sign Up for Free
            </button>
          </>
        )}
      </div>
    </header>
  );
}

export default Header;
